import { pathOr } from 'ramda';

import { IState } from '../../store';
import { IInfrastructureType } from '../../types/map/infrastructure';

export const selectInfrastructureTypes = (state: IState): IInfrastructureType[] | null => {
  const infrastructureTypes = pathOr<IInfrastructureType[] | null>(
    null,
    ['offerData', 'newObject', 'infrastructureTypes'],
    state,
  );

  return infrastructureTypes && infrastructureTypes.length > 0 ? infrastructureTypes : null;
};
